import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { classNames } from "../../components/common/base-component";
import LocaleStrings from "@language";
import moment from "moment";
import { fetchBalance } from "@transactionaction";

const SideBar = (props) => {
  let {
    routes,
    session,
    myBalance,
    eventData,
    conversionRate,
    localeLanguage,
  } = props;
  const location = useLocation();

  useEffect(() => {
    props.fetchBalance(session, eventData.useridfk);
  }, []);

  // creates the links that appear in the left menu
  const createLinks = () => {
    var routesNew = _.filter(routes, function (list) {
      return (
        list.display &&
        list.layout === "/admin" &&
        (list.section === "both" || list.section === session?.usertype)
      );
    }); // custom check is login not display in sidebar

    return routesNew.map((item, key) => {
      var selected = _.includes(location.pathname, item.path);

      return (
        <a
          key={item.name}
          href={`#${item.path}`}
          className={classNames(
            selected
              ? "bg-navsel text-theme font-semibold"
              : "text-gray-600 hover:bg-gray-50",
            "group flex items-center px-3 py-2 text-sm font-medium rounded-md"
          )}
          aria-current={selected ? "page" : undefined}
        >
          <item.icon
            className={classNames(
              selected
                ? "text-theme"
                : "text-gray-400 group-hover:text-blue-300",
              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
            )}
            aria-hidden="true"
          />
          <span className="truncate">{LocaleStrings[item.key]}</span>
        </a>
      );
    });
  };

  //console.log("conversionRate", conversionRate);

  let tokenamount = 1;
  if (
    conversionRate &&
    conversionRate.length > 0 &&
    conversionRate[0]["tokenamount"]
  ) {
    tokenamount = conversionRate[0]["tokenamount"];
  }
  let years = 0;
  if (myBalance?.data?.length > 0) {
    years = moment(myBalance.data[0].validuntil).diff(moment(), "years", false);
  }

  return (
    <>
      <div className="flex items-center justify-start font-bold border-b py-1.5">
        {eventData?.companyname}
      </div>
      {myBalance?.data?.length > 0 ? (
        <div className="py-2">
          <div className="text-2xl 2xl:text-3xl">
            {LocaleStrings.balance_text}: &nbsp;&euro;
            {(myBalance.data[0].totaltoken * tokenamount).toFixed(2)}
          </div>
          {years < 20 ? (
            <div className="text-xs">
              {LocaleStrings.valid_until}{" "}
              {moment(myBalance.data[0].validuntil).format("DD-MM-YYYY")}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      <nav
        aria-label="Sidebar"
        className="sticky top-4 divide-y divide-gray-300"
      >
        <div className="pb-8 space-y-6">{createLinks()}</div>
      </nav>

      <div className="flex items-center justify-center  py-2">
        <a
          href="https://www.tikwash.com/algemene-voorwaarden/"
          target="_blank"
          className="text-theme text-sm"
        >
          {LocaleStrings.termsnconditions}
        </a>
      </div>
      <div className="flex items-center justify-center py-2">
        <a
          href="https://www.tikwash.com/privacy-policy/"
          target="_blank"
          className="text-theme text-sm"
        >
          {LocaleStrings.privacypolicy}
        </a>
      </div>
      {eventData?.website ? (
        <div className="flex items-center justify-center py-2">
          <a
            href={
              eventData?.website.indexOf("http") >= 0
                ? eventData?.website
                : "http://" + eventData?.website
            }
            target="_blank"
            className="text-theme text-sm"
          >
            {eventData?.website}
          </a>
        </div>
      ) : (
        ""
      )}
      <div className="flex items-center justify-center text-gray-600 text-sm pt-6">
        &copy; Vema Projects bv
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    myBalance: state.myBalance,
    eventData: state.eventData,
    conversionRate: state.conversionRate.data,
    localeLanguage: state.localeLanguage,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchBalance }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
